module.exports = __webpack_public_path__ + "img/labmemtest_text_btn02_tc.7651a080.png";